// The server-issued device id, mirrored into IndexedDB.
//
// The authoritative copy is an HttpOnly cookie set by the Worker — JS can't
// read it. We keep a non-authoritative mirror here so the settings UI can
// display it and the engagement client can stamp it onto payloads. It is
// written only after a successful bind, i.e. strictly post-consent.

import { getMeta, setMeta } from "../store/db";

const KEY = "device_id";

export async function getDeviceId(): Promise<string | null> {
  const v = await getMeta(KEY);
  return typeof v === "string" && v.length > 0 ? v : null;
}

export async function setDeviceId(id: string): Promise<void> {
  await setMeta(KEY, id);
}

export async function clearDeviceId(): Promise<void> {
  // Empty string rather than delete so a later read returns "unbound" cleanly.
  await setMeta(KEY, "");
}
